const colorToClassMap = {
  error: 'c-lozenge--error',
  info: 'c-lozenge--info',
  primary: 'c-lozenge--primary',
  success: 'c-lozenge--success',
  warning: 'c-lozenge--warning',
};

export const LOZENGE_COLORS = Object.keys(colorToClassMap);
export const LOZENGE_CLASS_MAP = { color: colorToClassMap };
